export const generateStrings = ({
  appName,
  headers,
  meta,
}: {
  appName: string
  headers?: any
  meta: { title?: string; description?: string; translation?: string }
}) => {
  return {
    appName,
    headers,
    meta,
    title: 'Web Accessibility',
    monitoring: 'Monitoring',
    consulting: 'Consultants',
    fixer: 'Remedy',
    helper: 'Helper',
    customers: 'Get reports, monitoring, and core web vitals',
    trySearch: 'Free website accessibility scan',
    subTitle: 'Elevating accessibility for every website',
  }
}
